/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { Icon as DefIcon, type IconProps } from './Icon';

export const BurgerIcon = (props: IconProps) => (
  <DefIcon viewBox="0 0 24 24" {...props}>
    <path
      d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
      fill="currentColor"
    />
  </DefIcon>
);
